var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('div',{staticClass:"content_title content_700 mb-24"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"content_18 mb-48"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }